export default "__VITE_ASSET__7878ecbe__"